import { DailyForm } from "component/form";
import TextAutoTruncate from "component/TextAutoTruncate";
import { Fragment, useState } from "react";
import { useSearchParams } from "react-router-dom";

const DailyFormPage = () => {
  const [searchParams] = useSearchParams();
  const isHistoryString = searchParams.get("isHistory") === 'true'
  const [canEdit, setCanEdit] = useState<boolean>(!isHistoryString);

  return (
    <Fragment>
      <div className="page-title bg-[#EEEEEE] w-full sticky opacity-100 top-[90px] page-title-fixed z-10 pt-6 pb-1">
        <TextAutoTruncate>
          {`${searchParams.get("patient") || ""} - ${
            searchParams.get("seriveName") || ""
          }`}
        </TextAutoTruncate>
      </div>

      <div className="bg-white ">
        <DailyForm
          wrapperClassName="mb-[70px] pb-[10px]"
          showServiceName={false}
          canEdit={canEdit}
          setCanEdit={setCanEdit}
        />
      </div>
    </Fragment>
  );
};

export default DailyFormPage;
